import React, { useMemo } from "react"
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { Box } from "@mui/system"
import { customPalette } from "../../../../../../../../../../theme"
import { displayDecimal } from "../../../../../../../../../core/services/helper-service"

interface IProps {
  difference: number
}

export function DifferenceArrowIcon({ difference }: Readonly<IProps>): React.JSX.Element {
  const differenceLabel = useMemo(() => `(${displayDecimal(difference, 1)} pts)`, [difference])

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Arrow difference={difference} /> {differenceLabel}
    </Box>
  )
}

function Arrow({ difference }: Readonly<IProps>): React.JSX.Element {
  if (difference > 0.1) {
    return <ArrowDownwardIcon sx={{ color: customPalette.dashboardGreen }} />
  } else if (difference < -0.1) {
    return <ArrowUpwardIcon sx={{ color: customPalette.dashboardRed }} />
  } else {
    return <ArrowForwardIcon sx={{ color: customPalette.dashboardOrange }} />
  }
}
